itsoftApp.createModule("disclaimer", ["windowResize", "pageLoad", "cookie"], function () {
    const module = this;

    const Disclaimer = function () {
        this.footer = document.querySelector(".page-footer");
        this.disclaimer = document.querySelector(".js-disclaimer"); /* У дисклеймера должен быть такой класс */
        this.button = document.querySelector(".disclaimer__close-button"); /* Крестик */
        this.confirm = document.querySelector(".disclaimer__confirm"); /* элемент подтвеждения закрытия */
        this.text = document.querySelector(".disclaimer__text");
        this.disclaimerParts = document.querySelectorAll(".disclaimer__part");
        this.footerCoordY;
        this.sTop;
        this.requiredPercentage = 6;

        if (this.disclaimer) {
            this.init();
        }
    };

    Disclaimer.prototype.buttonMouseOver = function () {
        const DISCLAIMER = this;
        if (!this.disclaimer.classList.contains("js-hover")) {
            this.disclaimer.classList.add("js-hover");
            if (this.confirm) {
                this.confirm.addEventListener("mouseout", DISCLAIMER.buttonMouseOut.bind(DISCLAIMER));
            }
        }
    };

    Disclaimer.prototype.buttonMouseOut = function () {
        const DISCLAIMER = this;
        this.disclaimer.classList.remove("js-hover");
        this.confirm.removeEventListener("mouseout", DISCLAIMER.buttonMouseOut.bind(DISCLAIMER));
    };

    Disclaimer.prototype.close = function () {
        const DISCLAIMER = this;
        itsoftApp.modules.cookie.setCookie(DISCLAIMER.disclaimer, 86400);
        this.disclaimer.classList.add("js-static");
        this.disclaimer.classList.add("js-inactive");
        if (this.disclaimer.classList.contains("js-hover")) {
            this.disclaimer.classList.remove("js-hover");
        }
        if (this.confirm) {
            this.confirm.style.display = "none";
        }
        this.footer.classList.add("js-update");
    };

    Disclaimer.prototype.checkButton = function () {
        const DISCLAIMER = this;
        if (DISCLAIMER.button) {
            DISCLAIMER.button.addEventListener("mouseover", DISCLAIMER.buttonMouseOver.bind(DISCLAIMER));

            DISCLAIMER.button.addEventListener("click", function (evt) {
                evt.preventDefault();
                this.close = DISCLAIMER.close();
            });
        }
    };

    Disclaimer.prototype.checkConfirm = function () {
        const DISCLAIMER = this;
        if (DISCLAIMER.confirm) {
            DISCLAIMER.confirm.addEventListener("click", function (evt) {
                evt.preventDefault();
                this.close = DISCLAIMER.close();
            });
        }
    };

    Disclaimer.prototype.defineCoordY = function () {
        const DISCLAIMER = this;
        DISCLAIMER.footerCoordY = DISCLAIMER.footer.getBoundingClientRect().top + pageYOffset;
    };

    /* Вычисляем координаты. Если мы прокрутили страницу до подвала, делаем дисклеймер статичным */
    Disclaimer.prototype.checkElementCoords = function () {
        const DISCLAIMER = this;
        this.sTop = pageYOffset;
        if (this.sTop + document.documentElement.clientHeight > this.footerCoordY) {
            if (this.button) {
                this.button.classList.add("js-close-hide");
            }
            this.disclaimer.classList.add("js-inactive");
        } else if (!this.disclaimer.classList.contains("js-static")) {
            if (this.button) {
                this.button.classList.remove("js-close-hide");
            }
            this.disclaimer.classList.remove("js-inactive");
        } else {
            document.removeEventListener("scroll", DISCLAIMER.onDocumentScroll.bind(DISCLAIMER));
            window.removeEventListener("resize", DISCLAIMER.onDocumentResize.bind(DISCLAIMER));
        }
    };

    Disclaimer.prototype.onDocumentScroll = function () {
        const DISCLAIMER = this;
        DISCLAIMER.checkElementCoords();
    };

    Disclaimer.prototype.onDocumentResize = function () {
        /* Обновляем координаты при ресайзе */
        const DISCLAIMER = this;
        DISCLAIMER.calcFontSize();
        DISCLAIMER.defineCoordY();
        DISCLAIMER.checkElementCoords();
    };

    Disclaimer.prototype.init = function () {
        const DISCLAIMER = this;
        if (DISCLAIMER.disclaimer) {
            /* Инициализируем модуль после полной загрузки страницы, только если на странице есть дисклеймер */
            itsoftApp.modules.pageLoad.addEvent(function () {
                DISCLAIMER.disclaimer.getAttribute("data-save");
                DISCLAIMER.calcFontSize();

                if (DISCLAIMER.dAttrSave && !itsoftApp.modules.cookie.getCookie(DISCLAIMER.disclaimer)) {
                    DISCLAIMER.defineCoordY();
                    DISCLAIMER.checkElementCoords();
                } else if (!DISCLAIMER.dAttrSave) {
                    DISCLAIMER.defineCoordY();
                    DISCLAIMER.checkElementCoords();
                } else {
                    return;
                }

                document.addEventListener("scroll", DISCLAIMER.onDocumentScroll.bind(DISCLAIMER));
                window.addEventListener("resize", DISCLAIMER.onDocumentResize.bind(DISCLAIMER));
            });

            DISCLAIMER.checkButton();
            DISCLAIMER.checkConfirm();
        }
    };

    Disclaimer.prototype.getWordsSquare = function () {
        let square = 0;

        Array.prototype.forEach.call(this.disclaimerParts, function (word) {
            const blockW = word.clientWidth;
            const blockH = word.clientHeight;
            const currentSquare = blockW * blockH;
            square += currentSquare;
        });

        return square;
    };

    Disclaimer.prototype.getWindowSquare = function () {
        const bodyWidth = itsoftApp.utils.getViewportSize();
        const bodyHeight = itsoftApp.utils.getViewportHeight();
        return bodyWidth * bodyHeight;
    };

    Disclaimer.prototype.getFinalValue = function (square) {
        const percent = square * 100 / this.getWindowSquare();
        return percent > this.requiredPercentage;
    };

    Disclaimer.prototype.setFontSize = function (size) {
        this.text.style.fontSize = size + "px";
        this.text.setAttribute("data-font-size", size);
    };

    Disclaimer.prototype.getFontSize = function () {
        return parseInt(this.text.getAttribute("data-font-size"), 10) || 8;
    };

    Disclaimer.prototype.calcFontSize = function () {
        const DISCLAIMER = this;
        let counter = 0;
        DISCLAIMER.setFontSize(8);
        while (this.getFinalValue(this.getWordsSquare(), this.requiredPercentage) === false) {
            if ( counter++ > 100 ) break;
            DISCLAIMER.setFontSize(DISCLAIMER.getFontSize() + 2);
        }
        const fontSize = this.getFontSize();
        this.text.style.fontSize = fontSize + "px";
    };

    new Disclaimer();
    module.callback = Disclaimer;
});
